import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';

import {
    Paper,
    Box,
    Button,
    Typography,
    Stack,
    TextField,
    Link,
    Alert,
    Snackbar
} from '@mui/material';

const ApplyEmailPage = () => {

    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);

    // ビジネスプラン固定
    const planId = '2';

    const {
        handleSubmit,
        control,
        formState: { errors, isSubmitting }
    } = useForm({
        defaultValues: {
            email: ''
        }
    });

    const onSubmit = async (data) => {

        try {

            const res = await axiosInstance.post('/email', {
                email: data.email,
                plan_id: planId
            });

            navigate('/apply', {
                state: {
                    application_id: res.data.application_id,
                    plan_id: planId
                }
            });

        } catch (err) {

            setErrorMessage(
                err.response?.data?.message || '送信に失敗しました'
            );

            setOpenSnackbar(true);

        }

    };

    return (
        <Box sx={{ maxWidth: 520, mx: 'auto' }}>

            {/* タイトル */}
            <Typography component="h1" variant="h2" align="center" mb={1}>
                30日間無料トライアル
            </Typography>

            {/* 訴求 */}
            <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                flexWrap="wrap"
                my={2}
            >
                <Typography color={'primary'}>
                    ✔ クレジットカード不要
                </Typography>

                <Typography color={'primary'}>
                    ✔ 30秒で登録
                </Typography>

                <Typography color={'primary'}>
                    ✔ すぐ利用可能
                </Typography>
            </Stack>
            <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="body2">
                    ご入力いただいたメールアドレス宛に、
                    アカウント登録用リンクをお送りします。<br />
                </Typography>
            </Alert>
            <Alert severity="success" sx={{ mb: 2 }}>
                <Typography variant="body2">
                    ビジネスプランを30日間無料でお試しいただけます。<br />
                    クレジットカード登録は不要です。<br />
                    <strong>無料期間終了後、自動課金はありません。</strong>
                </Typography>
            </Alert>

            <Paper variant="section">

                <Typography component="h4" variant="h4">
                    メールアドレスを入力
                </Typography>

                <Box
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                    sx={{ mt: 3, mb: 5 }}
                >

                    <Stack spacing={2}>

                        <Controller
                            name="email"
                            control={control}
                            rules={{
                                required: 'メールアドレスを入力してください',
                                maxLength: {
                                    value: 255,
                                    message: '255文字以内で入力してください'
                                },
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: '正しいメールアドレス形式で入力してください'
                                }
                            }}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="メールアドレス"
                                    type="email"
                                    placeholder="example@company.com"
                                    error={!!errors.email}
                                    helperText={errors.email?.message}
                                    inputProps={{ maxLength: 255 }}
                                    autoComplete="email"
                                    onBlur={(e) =>
                                        field.onChange(
                                            e.target.value.trim().toLowerCase()
                                        )
                                    }
                                />
                            )}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            size="large"
                            disabled={isSubmitting}
                        >
                            {isSubmitting
                                ? '送信中…'
                                : '無料トライアルを開始'}
                        </Button>

                    </Stack>

                </Box>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    align="center"
                >
                    アカウントをお持ちですか？{' '}
                    <Link
                        component={RouterLink}
                        to={`${process.env.REACT_APP_ADMIN_URL}/login`}
                    >
                        サインイン
                    </Link>
                </Typography>

            </Paper>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackbar(false)}
            >
                <Alert severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>

        </Box>
    );
};

export default ApplyEmailPage;